import React, { useEffect, useRef, useState } from "react";
import "../App.css";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import Modal from "./Modal";
// JSON Data
const pageData = {
  hero: {
    videoSrc: "https://50-sunset.b-cdn.net/theme/dashboard/bg-video.mp4",
    introText: "Exclusive First Look at a Landmark in Refined Coastal Living",
    watchFilmText: "WATCH THE FILM",
    playButtonIcon: "/icons/playbtn.svg",
    scrollText: "SCROLL",
  },
  banner: {
    registerInterestText: "REGISTER INTEREST NOW",
  },
  sections: [
    // {
    //   type: "tags",
    //   content: `2 BED SKY HOMES FROM 95M<sup>2</sup><br />
    //             3 BED SKY HOMES FROM 130M<sup>2</sup><br />
    //             4 BED PENTHOUSE FROM 160M<sup>2</sup><br />
    //            `,
    // },
    {
      type: "text",
      content: `Exclusive First Look: Pre-Release Opportunity at 50 Sunset Boulevard, Surfers Paradise — a limited release of 72 stunning two- and three-bedroom sky homes surrounded by breathtaking vistas of the Pacific Ocean, Nerang River, and hinterland. These gorgeous architect-designed residences blend refined materials and elegant proportions to create an irreplaceable coastal address. Register now for first access to pricing and final designs when released.`,
    },
    // {
    //   type: "image",
    //   src: "/images/111.png",
    //   caption: "50 Sunset Surfers Paradise",
    // },
    {
      type: "video",
      src: "https://luka-test-pwa.b-cdn.net/theme/50sunset/50S_10sloop_2310.mp4",
      caption: "50 Sunset BVD Surfers Paradise",
    },
    {
      type: "cta",
      title: "A life beautifully elevated",
      description: ``,
      buttonText: "",
      link: "",
    },
    // {
    //   type: "gallery",
    //   items: [
    //     {
    //       src: "/images/102.jpeg",
    //       caption: "ARRIVAL CONSERVATORY, SKY HOMES — Artist’s impression",
    //     },
    //     {
    //       src: "/images/residences city-scape.png",
    //       caption: "RESIDENCES CITY SCAPE  — Artist’s impression",
    //     },
    //   ],
    // },
    {
      type: "gallery-video",
      items: [
        {
          src: "https://luka-test-pwa.b-cdn.net/theme/50sunset/left.mp4",
          caption: "ARRIVAL CONSERVATORY, SKY HOMES — Artist’s impression",
        },
        {
          src: "https://luka-test-pwa.b-cdn.net/theme/50sunset/right.mp4",
          caption: "RESIDENCES CITY SCAPE  — Artist’s impression",
        },
      ],
    },
    // {
    //   type: "cta",
    //   title: "RELAX YOU ARE HOME",
    //   description: `The Loft Residences at the Paint Factory are uncompromising homes
    //                 for those who expect the exceptional. Spanning 250-square-metre
    //                 floorplates, each light-filled loft pairs raw industrial character
    //                 with refined finishes, opening onto sweeping views of the Brisbane
    //                 River corridor and the city skyline.`,
    //   buttonText: "DISCOVER MORE",
    // },
    // {
    //   type: "image",
    //   src: "/images/108.png",
    //   caption: "SEASCAPE SKY HOMES MASTER SUITE",
    // },
    {
      type: "iframe",
      src: "https://storage.net-fs.com/hosting/7566552/168/",
      title: "AND THE VIEW..,",
    },
    // {
    //   type: "cta",
    //   title: "Paint Factory Precinct",
    //   description: `This exclusive lifestyle stretches well beyond your loft’s
    //                 industrial-chic interiors, unlocking private galleries, rooftop
    //                 gardens, wellness studios and chef-run eateries—all overseen by a
    //                 resident concierge team.`,
    //   buttonText: "DISCOVER MORE",
    //   link: "#",
    // },
    // {
    //   type: "image",
    //   src: "/images/104.png",
    //   caption: "LIFESTYLE",
    // },
    // {
    //   type: "video",
    //   src: "https://paintfactory.metaluxe.com.au/theme/paintfactory/lifestyle.mp4",
    //   caption: "LIFESTYLE",
    // },
    // {
    //   type: "cta",
    //   title: "Too Green?",
    //   description: `Can you be too green? Never. The Paint Factory in Yeronga proves
    //                 you can never overdo sustainability, weaving ecological living
    //                 into every brick and beam.`,
    //   buttonText: "DISCOVER MORE",
    //   link: "#",
    // },

    {
      type: "grid",
      items: [
        {
          title: "RANA",
          src: "/images/azariah.png",
          description: ``,
          linkText: "",
        },
        {
          title: "AZARIAH",
          src: "/images/rana.png",
          description: ``,
          linkText: "",
        },
        // {
        //   title: "ARTS to LIFESTYLE",
        //   src: "/images/lifestyle.jpg",
        //   description: `The Paint Factory’s galleries and studios spark Brisbane’s
        //                 creative heart, delivering immersive spaces where art is
        //                 crafted, showcased and lived.`,
        //   linkText: "DISCOVER MORE",
        // },
      ],
    },
  ],
};

// Template Code

const Home = () => {
  const [isVideoOpen, setIsVideoOpen] = useState(false);

  useEffect(() => {
    const sections = document.querySelectorAll(".fade-in-section");
    const banners = document.querySelectorAll(".animate-slide-in-left");

    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    banners.forEach((banner) => observer.observe(banner));
    sections.forEach((section) => observer.observe(section));

    return () => {
      sections.forEach((section) => observer.unobserve(section));
      banners.forEach((banner) => observer.unobserve(banner));
    };
  }, []);

  const nextSectionRef = useRef(null);

  const scrollToNextSection = () => {
    nextSectionRef.current.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="font-sans">
      <main>
        <section id="hero" className="bg-gray-100">
          <div className="relative">
            <video autoPlay muted controls={false} loop>
              <source src={pageData.hero.videoSrc} type="video/mp4" />
            </video>
            <div className="intro w-full md:w-1/2">
              <h1>{pageData.hero.introText}</h1>
              <div
                className="flex-center mt-36 mb-6"
                onClick={() => setIsVideoOpen(true)}
              >
                <img
                  src={pageData.hero.playButtonIcon}
                  style={{ height: "25px" }}
                  className="mr-2"
                  alt="Play Button"
                />
                <p className="border-white border-b-2 intro_title">
                  {pageData.hero.watchFilmText}
                </p>
              </div>
            </div>
            <div className="scroll" onClick={scrollToNextSection}>
              <p className="text-white">{pageData.hero.scrollText}</p>
              <svg
                data-name="Layer 1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 9.81 30"
                className="arrow"
              >
                <path fill="none" stroke="#fff" d="M4.91 0v24.8"></path>
                <path fill="#fff" d="M4.91 30l4.9-5.27H0L4.91 30z"></path>
              </svg>
            </div>
          </div>
        </section>

        <div id="banner" ref={nextSectionRef}>
          <div className="animate-slide-in-left">
            <div className="banner_slide flex-center">
              <p className="text-p">{pageData.banner.registerInterestText}</p>
            </div>
          </div>
        </div>

        {pageData.sections.map((section, index) => {
          if (section.type === "tags") {
            return (
              <section key={index} className="my-16">
                <div
                  className="fade-in-section mx-8 text-p uppercase"
                  dangerouslySetInnerHTML={{ __html: section.content }}
                ></div>
              </section>
            );
          }
          if (section.type === "text") {
            return (
              <section class="mb-28 mt-24">
                <div class="fade-in-section section-entry show">
                  <p class="text-p-s">{section.content}</p>
                </div>
              </section>
            );
          } else if (section.type === "image") {
            return (
              <section key={index} className="my-16">
                <div className="fade-in-section">
                  <img
                    src={section.src}
                    className="mt-8 w-auto m-auto"
                    alt=""
                  />
                  <p className="text-p-m mt-2">{section.caption}</p>
                </div>
              </section>
            );
          } else if (section.type === "video") {
            return (
              <section key={index} className="mt-16 mb-0">
                <div className="fade-in-section">
                  <video
                    autoPlay
                    muted
                    controls={false}
                    loop
                    className="mt-8 w-auto m-auto"
                  >
                    <source src={section.src} type="video/mp4" />
                  </video>
                  <p className="text-p-m mt-2">{section.caption}</p>
                </div>
              </section>
            );
          } else if (section.type === "iframe") {
            return (
              <section key={index} className="mt-8 mb-16">
                <div className="fade-in-section text-center px-8">
                  <h1 className="header text-4xl text-black tracking-widest mb-8">
                    {section.title}
                  </h1>
                  <iframe
                    src={section.src}
                    className="w-full h-auto md:h-[100vh]"
                  ></iframe>
                </div>
              </section>
            );
          } else if (section.type === "cta") {
            return (
              <section key={index} className="mt-8 mb-16">
                <div className="fade-in-section text-center px-8">
                  <h1 className="header text-4xl text-black tracking-widest">
                    {section.title}
                  </h1>
                  {/* <p className="text-p-xxxs my-8 section-entry py-8">
                    {section.description}
                  </p> */}
                  {section.link && (
                    <Link to={section.link} reloadDocument>
                      <button className="btn">{section.buttonText}</button>
                    </Link>
                  )}
                </div>
              </section>
            );
          } else if (section.type === "gallery") {
            return (
              <section key={index} className="my-16">
                <div className="shell">
                  <div className="fade-in-section mt-16 m-auto">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-24 md:gap-6 px-8">
                      {section.items.map((item, idx) => (
                        <div key={idx}>
                          <img
                            src={item.src}
                            className="h-full object-cover"
                            alt=""
                          />
                          <p className="text-p-m mt-3">{item.caption}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </section>
            );
          } else if (section.type === "gallery-video") {
            return (
              <section key={index} className="my-16">
                <div className="shell">
                  <div className="fade-in-section mt-16 m-auto">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-24 md:gap-6 px-8">
                      {section.items.map((item, idx) => (
                        <div key={idx}>
                          <video
                            src={item.src}
                            className="h-full object-cover"
                            autoPlay
                            muted
                            playsInline
                            loop
                            controls={false}
                          />
                          <p className="text-p-m mt-3">{item.caption}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </section>
            );
          } else if (section.type === "grid") {
            return (
              <section key={index} className="mb-16 mt-16">
                <div className="shell">
                  <div className="fade-in-section">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      {section.items.map((item, idx) => (
                        <div key={idx} className="flex flex-col">
                          <div className="border-top">
                            <p className="title pt-8 pb-4">{item.title}</p>
                          </div>
                          <img src={item.src} className="my-5 " alt="" />
                          <p className="text-p-xs pt-2 pb-3 h-[95px]">
                            {item.description}
                          </p>
                          <a href="#" className="text-p-xs underline">
                            {item.linkText}
                          </a>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </section>
            );
          }
          return null;
        })}

        <Footer />
        <div className="fixed bottom-2 right-2">
          <img src="/images/macquarie-logo.png" className="w-32" />
        </div>
      </main>

      <Modal isOpen={isVideoOpen} setIsOpen={setIsVideoOpen}>
        <video
          autoPlay={true}
          playsInline={true}
          muted={false}
          controls={true}
          loop={true}
          className="w-full h-full object-cover"
        >
          <source
            src={`https://luka-test-pwa.b-cdn.net/theme/50sunset/50S_10sloop_2310.mp4`}
            type="video/mp4"
          />
        </video>
      </Modal>
    </div>
  );
};

export default Home;
